import { Box, Card, CardActions, CardContent, CardHeader } from '@mui/material';
import { CONTAINER, FORM, useLoginForm } from '.';
import { FormProvider } from 'react-hook-form';
import { BpInput } from '../common';
import { useEffect } from 'react';
import { BpButton } from '../common/BpButton';
import { useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../hooks/use-authentication';

export const Login = () => {
  useAuthentication();
  const { form, handleSubmit, isLoading, value } = useLoginForm();
  const navigate = useNavigate();

  useEffect(() => {
    if (value && value.includes('v2')) {
      navigate(value);
    }
  }, [navigate, value]);

  return (
    <FormProvider {...form}>
      <Box sx={CONTAINER}>
        <Card component='form' onSubmit={handleSubmit}>
          <CardHeader title='Se connecter' />
          <CardContent>
            <Box sx={FORM}>
              <BpInput label='Adresse email' name='email' />
              <BpInput label='Mot de passe' name='password' type='password' />
            </Box>
          </CardContent>
          <CardActions>
            <BpButton type='submit' loading={isLoading}>
              Envoyer
            </BpButton>
          </CardActions>
        </Card>
      </Box>
    </FormProvider>
  );
};
